export const reviewApplicationAction = (data) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(application);
      firestore
        .collection("applications")
        .doc(data.id)
        .update({
            division: data.division,
            programme: data.programme,
            classCode: data.classCode,
            applicationStatus: 'accepted'
        })
        .then(() => {
          dispatch({
            type: "ACCEPTED_REVIEW",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ACCEPTED_REVIEW_ERR",
            err
          });
        });
    };
  };
  